import { GetStaticPaths, GetStaticProps } from "next";
import { FunctionComponent, useEffect } from "react";
import {
  AccountCredits,
  AccountCreditsCopy,
} from "@bluebottlecoffee/design-system/components";
import { useUser } from "@chordcommerce/react-autonomy";
import {
  getStaticAccountPaths,
  getStaticAccountProps,
  PageData,
} from "../../../../lib/sanity/account-shared-queries";
import { AccountPage } from "../../../../components/AccountPage";

export const getStaticProps: GetStaticProps<PageData<AccountCreditsCopy>> =
  getStaticAccountProps("AccountCredits");

export const getStaticPaths: GetStaticPaths = getStaticAccountPaths;

const Credits: FunctionComponent<PageData<AccountCreditsCopy>> = (props) => {
  const { pageCopy } = props;
  const { user, loadUser } = useUser();

  const credit = user.data?.storeCredit;
  const floatCredits =
    typeof credit === "string" ? Number.parseFloat(credit) : credit;

  useEffect(() => {
    if (!user.data?.id) {
      loadUser();
    }
  }, [user, loadUser]);

  const balance = {
    accountBalance: Math.round(floatCredits * 100) || 0, // chord uses dollars, not cents
    freeShippingCreditBalance: 0,
  };

  return (
    <AccountPage {...props} pageTitle={pageCopy.title}>
      <AccountCredits copy={pageCopy} balance={balance} />
    </AccountPage>
  );
};

export default Credits;
